import { render } from "./IncidentsOpen.vue?vue&type=template&id=ca4b9ec8"
import script from "./IncidentsOpen.vue?vue&type=script&lang=js"
export * from "./IncidentsOpen.vue?vue&type=script&lang=js"

import "./IncidentsOpen.vue?vue&type=style&index=0&id=ca4b9ec8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__